import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Palette, themeConfig, useThemeContext } from '@/shared/theme';

const BackdropContainer = styled.div<{ colors: Palette }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  &::before {
    content: '';
    background-color: ${(props) => props.colors.bgBase};
    opacity: 0.8;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const Backdrop = ({ children }: PropsWithChildren) => {
  const { theme } = useThemeContext();
  const colors = themeConfig[theme].colors;

  return <BackdropContainer colors={colors}>{children}</BackdropContainer>;
};
